/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Select_File_From_ComputerInputs */

const en_common_select_file_from_computer = /** @type {(inputs: Common_Select_File_From_ComputerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a file from your computer`)
};

const es_common_select_file_from_computer = /** @type {(inputs: Common_Select_File_From_ComputerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un archivo de tu computadora`)
};

/**
* | output |
* | --- |
* | "Select a file from your computer" |
*
* @param {Common_Select_File_From_ComputerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_select_file_from_computer = /** @type {((inputs?: Common_Select_File_From_ComputerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Select_File_From_ComputerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_select_file_from_computer(inputs)
	return en_common_select_file_from_computer(inputs)
});